import React from 'react';
import Icon from '../shared/components/Icon';
import { Link } from '../../features/ui';
import ios from './footer-ios.svg';
import android from './footer-android.svg';
import { useT } from '@mrkt/features/i18n';
import { useFooterLabels } from '../../features/Layout/Footer/useFooterLabels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var year = new Date().getFullYear();
var TRACK_CAT = 'Footer';
export default function Footer() {
  var t = useT();
  var footerLabels = useFooterLabels();
  return /*#__PURE__*/_jsx("footer", {
    className: "footer footer-default",
    role: "contentinfo",
    children: /*#__PURE__*/_jsxs("div", {
      className: "container",
      children: [/*#__PURE__*/_jsxs("nav", {
        className: "row",
        "aria-label": t('FRODOR_FOOTER_LINKS', 'Links to Spotify resources', 'collection of links in the footer'),
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-md-2",
          children: /*#__PURE__*/_jsx("div", {
            className: "footer-logo",
            children: /*#__PURE__*/_jsx(Link, {
              external: true,
              href: "https://www.spotify.com",
              track: [TRACK_CAT, 'Logo'],
              children: "Spotify"
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-xs-12 col-sm-4 col-md-2",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "nav-title",
            children: t('FRODOR_0aeec8', 'Helpful Links', 'Link refers to web link')
          }), /*#__PURE__*/_jsxs("ul", {
            className: "nav",
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://www.spotify.com/about-us/contact/",
                track: [TRACK_CAT, 'About'],
                children: t('FRODOR_2b48af', 'About', '')
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://newsroom.spotify.com",
                track: [TRACK_CAT, 'Press & Media'],
                children: t('FRODOR_f24f14', 'Press & Media', 'Press means newspapers or journalists viewed collectively')
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: "/contact",
                "data-testid": "footer-contact",
                track: [TRACK_CAT, 'Contact Us'],
                prefetch: false,
                children: t('FRODOR_51f8e4', 'Contact Us', '')
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-xs-12 col-sm-4 col-md-2",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "nav-title",
            children: t('FRODOR_914d07', 'Creator Tools', '')
          }), /*#__PURE__*/_jsxs("ul", {
            className: "nav",
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://app.adjust.com/iya18ah?redirect=https%3A%2F%2Fanchor.fm%2Fapp",
                track: [TRACK_CAT, 'Creator Tools - Anchor'],
                children: "Anchor"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://www.soundtrap.com/?utm_source=spotify_site&utm_medium=footer_menulink&utm_campaign=alwayson_global_soundtrap_destination",
                track: [TRACK_CAT, 'Creator Tools - Soundtrap'],
                children: "Soundtrap"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://podcasters.spotify.com/?utm_source=artists.spotify.com",
                track: [TRACK_CAT, 'Creator Tools - Spotify for Podcasters'],
                children: "Spotify for Podcasters"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://noteable.spotify.com/?utm_source=artists.spotify.com",
                track: [TRACK_CAT, 'Creator Tools - Noteable'],
                children: "Noteable"
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-xs-12 col-sm-4",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "nav-title",
            children: t('FRODOR_8cca0b', 'Get the app', '')
          }), /*#__PURE__*/_jsx(Link, {
            external: true,
            href: "https://itunes.apple.com/us/app/spotify-for-artists/id1222021797",
            track: [TRACK_CAT, 'iOS App'],
            children: /*#__PURE__*/_jsx("img", {
              style: {
                width: '170px'
              },
              src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
              "data-src": ios,
              className: "lazyload",
              alt: footerLabels.appStore
            })
          }), /*#__PURE__*/_jsx(Link, {
            external: true,
            href: "https://play.google.com/store/apps/details?id=com.spotify.s4a",
            track: [TRACK_CAT, 'Andriod App'],
            children: /*#__PURE__*/_jsx("img", {
              style: {
                width: '170px',
                marginTop: '12px'
              },
              src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
              "data-src": android,
              className: "lazyload",
              alt: footerLabels.googlePlay
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-md-2 col-social",
          children: /*#__PURE__*/_jsxs("ul", {
            className: "nav",
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsxs(Link, {
                external: true,
                href: "https://twitter.com/spotifyartists",
                track: [TRACK_CAT, 'Social - Twitter'],
                children: [/*#__PURE__*/_jsx(Icon, {
                  name: "twitter-icon",
                  className: "social-icon"
                }), /*#__PURE__*/_jsx("span", {
                  className: "social-text",
                  children: "Twitter"
                })]
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsxs(Link, {
                external: true,
                href: "https://www.instagram.com/spotifyforartists/",
                track: [TRACK_CAT, 'Social - Instagram'],
                children: [/*#__PURE__*/_jsx(Icon, {
                  name: "instagram-icon",
                  className: "social-icon"
                }), /*#__PURE__*/_jsx("span", {
                  className: "social-text",
                  children: "Instagram"
                })]
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs("nav", {
        className: "row row-small",
        "aria-label": t('FRODOR_FOOTER_LEGAL', 'Links to Spotify legal resources', 'collection of links in the footer'),
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-xs-7 col-md-6 col-md-offset-2",
          children: /*#__PURE__*/_jsxs("ul", {
            className: "nav nav-small",
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://www.spotify.com/legal/spotify-for-artists-terms-and-conditions/",
                track: [TRACK_CAT, 'Legal'],
                children: t('FRODOR_LEGAL_ROOT_FOOTER', 'Legal', 'Legal refers to terms and conditions')
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://www.spotify.com/legal/privacy-policy/",
                track: [TRACK_CAT, 'Privacy Policy'],
                children: t('FRODOR_a92e8f', 'Privacy Policy', '')
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                href: "https://www.spotify.com/legal/cookies-policy/",
                track: [TRACK_CAT, 'Cookies'],
                children: t('FRODOR_81cd99', 'Cookies', 'Cookies are a user tracking method for the web')
              })
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "col-xs-5 col-md-4 text-right",
          children: /*#__PURE__*/_jsxs("small", {
            className: "copyright",
            children: ["\xA9 ", year, " Spotify AB"]
          })
        })]
      })]
    })
  });
}